import { Flex } from "emoreg/layouts";
import { rem } from "polished";

import { Icon } from "../Icon";

import { MONTHS } from "./constants";
import { DateSelectorStyle } from "./styles";
import { getMonthString, getNextMonth, getPreviousMonth } from "./utils";

export type DateSelectorProps = {
  /** month to display (format YYYY-MM) */
  targetMonth: string;
  /** value change handler (only expose new value) */
  onChangeValue?: (month: string) => void;
};

export const DateSelector = ({ targetMonth, onChangeValue }: DateSelectorProps) => {
  const [year, month] = targetMonth.split("-").map(Number);

  const onPreviousMonth = () => {
    const [prevYear, prevMonth] = getPreviousMonth(year, month);
    onChangeValue?.(getMonthString(prevYear, prevMonth));
  };

  const onNextMonth = () => {
    const [nextYear, nextMonth] = getNextMonth(year, month);
    onChangeValue?.(getMonthString(nextYear, nextMonth));
  };

  return (
    <Flex gap={4} alignItems="center">
      <Flex alignItems="center">
        <DateSelectorStyle.Button onClick={onPreviousMonth}>
          <Icon size={rem(20)} name="arrowBack" />
        </DateSelectorStyle.Button>
        <DateSelectorStyle.Button onClick={onNextMonth}>
          <Icon size={rem(20)} name="arrowForward" />
        </DateSelectorStyle.Button>
      </Flex>
      <DateSelectorStyle.Title>
        {MONTHS[month - 1]} {year}
      </DateSelectorStyle.Title>
    </Flex>
  );
};
